import { render, staticRenderFns } from "./prop1.vue?vue&type=template&id=2c5286ef&scoped=true&"
import script from "./prop1.vue?vue&type=script&lang=js&"
export * from "./prop1.vue?vue&type=script&lang=js&"
import style0 from "./prop1.vue?vue&type=style&index=0&id=2c5286ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5286ef",
  null
  
)

export default component.exports